var LanguageSwitcher = /** @class */ (function () {
    function LanguageSwitcher() {
        this.languageMenuContainer = document.querySelector('[data-language-menu]');
        // Verify that the language menu container exists
        if (document.contains(this.languageMenuContainer)) {
            this.languageMenuToggle = this.languageMenuContainer.querySelector('.language-switch-link');
            this.attachListeners();
        }
    }
    LanguageSwitcher.prototype.attachListeners = function () {
        var _this = this;
        this.languageMenuToggle.addEventListener('click', function () { return _this.toggleLanguageMenu(); });
    };
    LanguageSwitcher.prototype.toggleLanguageMenu = function () {
        if (this.languageMenuContainer.classList.contains('active')) {
            this.languageMenuContainer.classList.remove('active');
        }
        else {
            this.languageMenuContainer.classList.add('active');
        }
    };
    return LanguageSwitcher;
}());
export default LanguageSwitcher;
